import { AbyssCommonContent } from "../AbyssCommonContent/AbyssCommonContent";
import { AbyssMedia } from "../AbyssMedia/AbyssMedia";
import type { IHeroSplitImageProps } from "./HeroSplitImage.props";

export const HeroSplitImage = ({
  alignment,
  buttons,
  description,
  eyebrow,
  heading,
  image,
}: IHeroSplitImageProps) => (
  <div
    className="abyss-instrument-frame grid min-w-0 overflow-hidden rounded-xl border border-iron bg-obsidian shadow-[0_32px_100px_rgba(0,0,0,0.36)] md:min-h-[42rem] md:grid-cols-[0.9fr_1.1fr]"
    data-calibrated="true"
  >
    <AbyssMedia
      aspectRatio={image.aspectRatio || "16:9"}
      className="h-full min-h-80 min-w-0 w-full md:order-2"
      imageClassName="h-full object-cover transition-transform duration-300 ease-out hover:scale-[1.015]"
      media={image.image}
      priority
      sizes="(min-width: 768px) 55vw, 100vw"
    />
    <AbyssCommonContent
      alignment={alignment}
      buttons={buttons}
      className="min-w-0 justify-center p-7 md:order-1 md:p-12 lg:p-16"
      description={description}
      eyebrow={eyebrow}
      heading={heading}
      headingAs="h1"
      headingClassName="abyss-type-hero max-w-[15ch]"
      tone="dark"
    />
  </div>
);

HeroSplitImage.displayName = "Content::HeroSplitImage";
